import styled from 'styled-components';

export const Form = styled.form`
  background-color: var(--white);
  padding: 20px;
  width: 100%;
  max-width: 800px;
  border-radius: 10px;
`;

export const DsFlex = styled.div`
  display: flex;
  justify-content: space-between;
  flex-direction: column;

  @media (min-width: 30.5em) {
    flex-direction: row;
  }

  & > div {
    flex: 1;
    margin-right: 10px;

    &:last-of-type {
      margin-right: 0;
    }
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-gap: 10px;

  @media (min-width: 30.5em) {
    grid-template-columns: repeat(auto-fill, minmax(336px, 1fr));
  }
`; 

export const Submit = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const RecentSearches = styled.div`
  h3{
    font-size: 1em;
    color: #ACB0C1;
  }

  ul {
    list-style: none;
  }

  li{
    margin-left: 10px;
  }

  ul > div{
    padding: 10px 10px;
    transition: 0.5s background-color;
    border-radius: 5px;
    cursor: pointer;

    &:hover{
      background-color: rgba(189, 195, 199, .2);      
    }
  }
`;

export const CenterVert = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: calc(100vh - 180px);
`;